var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vehicle-picker',{attrs:{"label":"Vehicle","allow-addition":false,"disabled":_vm.disabled},model:{value:(_vm.vehicleProxy),callback:function ($$v) {_vm.vehicleProxy=$$v},expression:"vehicleProxy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }